import React from 'react';
import Avatar from "@material-ui/core/Avatar";
import Menu from "@material-ui/core/Menu";
import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";
import Skeleton from "@material-ui/lab/Skeleton";
import {makeStyles} from "@material-ui/styles";
import {Link} from "react-router-dom";

const useStyles = makeStyles((theme) => ({
    avatar: {
        margin: '0 16px',
        backgroundColor: '#fff',
        color: theme.palette.primary.dark,
        "&:hover": {
            cursor: 'pointer'
        },
    }
}))


export const ProfileMenu = ({firstName, onLogOutButtonClick, loading}) => {
    const classes = useStyles()
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    }

    const handleClose = () => {
        setAnchorEl(null);
    }
    if (loading) {
        return <Skeleton variant="circle" width={40} height={40}/>
    }
    return <>
        <Avatar className={classes.avatar}
                onClick={handleClick}>
            {firstName.slice(0, 1)}
        </Avatar>
        <Menu anchorOrigin={{vertical: "bottom", horizontal: "center"}}
              transformOrigin={{vertical: "top", horizontal: "center"}}
              getContentAnchorEl={null}
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleClose}
              style={{}}
        >
            <MenuItem component={Link} to={'/profile'}>
                <ListItemText primary={"Профиль"}/>
            </MenuItem>
            <MenuItem onClick={onLogOutButtonClick}>
                <ListItemText primary="Выйти"/>
            </MenuItem>
        </Menu>
    </>
}